import { __require as o } from "./isObject.js";
var e, i;
function c() {
  if (i) return e;
  i = 1;
  var t = o();
  function a(r) {
    return r === r && !t(r);
  }
  return e = a, e;
}
export {
  c as __require
};
